<template>  
    <b-form>
        <div class="title"> {{$t('user.login.welcome')}} </div>
        <b-input-group >
            <b-input-group-prepend is-text>
                <b-icon icon="person-fill"></b-icon>
            </b-input-group-prepend>
            <b-form-input id="userName" v-model="username" type="text" required :placeholder="$t('user.login.username')" ></b-form-input>
        </b-input-group>
        <b-input-group >
            <b-input-group-prepend is-text>
                <b-icon icon="lock-fill"></b-icon>
            </b-input-group-prepend>
            <b-form-input  id="pass" v-model="password" type="password" required :placeholder="$t('user.login.password')" ></b-form-input>
        </b-input-group>
        <div class="links">
            <b-form-checkbox id="remember" v-model="rememberMe"  name="remember"> {{$t('user.login.rememberMe')}} </b-form-checkbox>
           <!-- <span> {{$t('user.login.forgotPassword')}} </span>-->
        </div>
        

        <div class="submitButton" variant="danger" @click="login"> {{$t('user.login.login')}} </div>
    </b-form>
</template>

<style lang="css" scoped> 
    @import "../styles/login.min.css"; 
</style>
<script>
    export default {
        name: "LoginForm",
        data: function(){
            return{
                username: this.$cookie.get('username')? this.$cookie.get('username') :"",
                password: this.$cookie.get('password')? this.$cookie.get('password') :"",
                rememberMe: this.$cookie.get('rememberMe')? this.$cookie.get('rememberMe') :false
            }
        },
        methods:{
            login: function(){
                if(this.rememberMe){
                    this.$cookie.set('username', this.username);
                    this.$cookie.set('password', this.password);
                    this.$cookie.set('rememberMe', this.rememberMe);
                }else{
                    this.$cookie.delete('username');
                    this.$cookie.delete('password');
                    this.$cookie.delete('rememberMe');
                }
                let data = {
                  username: this.username,
                  password: this.password  
                }
                this.onLogin(data)
            }
        },
        props:{
            onLogin: Function,
            message: Object
        }
    }
</script>

<!-- 
<b-alert v-if="login.status == 'Error'" show variant="danger">
            <h4 class="alert-heading">Hata!</h4>
            <p> Giriş yapılırken bir hata meydana geldi </p>
            <hr>
            <p class="mb-0"> {{login.message}}</p>
        </b-alert>
-->


// WEBPACK FOOTER //
// src/pages/General/Users/components/LoginForm.vue